import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import pImg1 from "../../images/gallery/image-1.jpg";
import pImg2 from "../../images/gallery/image-2.jpg";
import pImg3 from "../../images/gallery/image-3.jpg";
import pImg4 from "../../images/gallery/image-4.jpg";
import pImg5 from "../../images/gallery/image-5.jpg";
import pImg6 from "../../images/gallery/image-6.jpg";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// ✅ Interface for each portfolio item
interface PortfolioItem {
    Pimg: string;
}

// ✅ Props interface
interface PortfolioSectionProps {
    ptClass?: string;
}

const Portfolios: PortfolioItem[] = [
    { Pimg: pImg1 },
    { Pimg: pImg2 },
    { Pimg: pImg3 },
    { Pimg: pImg4 },
    { Pimg: pImg5 },
    { Pimg: pImg6 },
];

const PortfolioSection: React.FC<PortfolioSectionProps> = ({ ptClass }) => {
    const [open, setOpen] = useState(false);

    return (
        <section
            className={`wpo-portfolio-section section-padding ${ptClass || ""}`}
            id="gallery"
        >
            <h2 className="hidden">Portfolio</h2>
            <div className="container-fluid">
                <div className="portfolio-grids">
                    <Swiper
                        spaceBetween={20}
                        slidesPerView={5}
                        loop={true}
                        speed={1000}
                        breakpoints={{
                            1500: { slidesPerView: 5 },
                            1200: { slidesPerView: 3 },
                            991: { slidesPerView: 2 },
                            767: { slidesPerView: 1 },
                        }}
                    >
                        {Portfolios.map((image, i) => (
                            <SwiperSlide key={i}>
                                <div className="grid">
                                    <div className="img-holder" onClick={() => setOpen(true)}>
                                        <img
                                            src={image.Pimg}
                                            alt={`Gallery ${i + 1}`}
                                            className="img img-responsive"
                                        />
                                        <div className="hover-content">
                                            <i className="ti-plus"></i>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>

            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={Portfolios.map((item) => ({ src: item.Pimg }))}
            />
        </section>
    );
};

export default PortfolioSection;
